import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom'
// import Modal from "react-modal";
import "./mainTable.scss";
import Checkbox3 from "../checkbox/Checkbox3";
import { SHOW_MAIN_ERROR_MODAL } from '../../../redux/errorMessageSlice';
import Checkbox1 from "../checkbox/Checkbox1";
import { PrintData1d } from '../../../comonComponent/print-1d/PrintLottery';
import PlaceBat2d from '../place-bat/PlaceBat2d';
import { setAdvanceTimeSlotCount, selectAdvaceTimeSlotCount } from '../../../redux/seriesSlice';

import { SET_MAIN_LOADER } from "../../../redux/loaderSlice";
import {
  SelectSeriesPartAll,
  RESET_1D_SLICE_STATE,
  SelectSeriesPart,
  SET_SERIES_PART_CHECKED,
  SET_SERIES_TYPE,
  SelectSeriesType,
  SET_ACTIVE_SERIES_INDEX,
  SelectActiveSeriesPartIndex, SET_LAST_INPUT_CHANGE_RECORD,
  SelectActiveSeriesIndex,
  SET_ACTIVE_SERIES_PART_INDEX,
  SelecrSeriesStore,
  SET_PREVIEWS_ACTIVE_SERIES_DETAIL,
  SelectSeriesTypeDisableFlag,
  SET_IS_MULTI,
  SelectIsMulti,
  SET_SERIES_STORE,
  SET_RESULT_ARRAY,
  SelectResultArray
} from "../../../redux/1d-slice/seriesSlice1d";
import { SET_1D_ADVANCE_DRAW_SELECT_TIME, SET_1D_CLAIM_TICKET_ID, Select1dAdvanceDrawSelectTime, Select1dPrintData, SET_1D_LAST_SALE_AMOUNT, SET_1D_LAST_TICKET_ID, SET_1D_PRINT_DATA } from '../../../redux/1d-slice/gameInfo1dSlice';
import { useDispatch, useSelector } from "react-redux";
import SideTableSeriesCheckbox from "./component/SideTableSeriesCheckbox";
import HorizontalInputContainer from "./component/HorizontalInputContainer";
import VerticalInputContainer from "./component/VerticalInputContainer";
import RightResultContainer from "./component/RightResultContainer";
import { SocketState } from "../../../context/SocketProvider";
import { AuthState } from "../../../context/AuthProvider";

function MainTable() {
  const dispatch = useDispatch();
  const { socket } = SocketState()
  const { userDetail } = AuthState()
  const seriesStore = useSelector(SelecrSeriesStore);
  const selectSeriesPart = useSelector(SelectSeriesPart);
  const activeSeriesIndex = useSelector(SelectActiveSeriesIndex);
  const activeSeriesPartIndex = useSelector(SelectActiveSeriesPartIndex);
  const isMulti = useSelector(SelectIsMulti);
  const advaceTimeSlotCount = useSelector(selectAdvaceTimeSlotCount);

  const [totalCount, setTotalCount] = useState(0);


  const resultArray = useSelector(SelectResultArray);
  const AdvanceDrawSelectTime = useSelector(Select1dAdvanceDrawSelectTime);

  const navigate = useNavigate()

  const [showWhatsappPopup1d, setShowWhatsappPopup1d] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");

  let seriesType = useSelector(SelectSeriesType)
  let seriesTypeDisableFlag = useSelector(SelectSeriesTypeDisableFlag)

  // input ref
  const inputRefs = useRef([]);
  // HorizontalInput ref
  const horizontalInputRefs = useRef([]);
  // verticalInput ref
  const verticalInputaRefs = useRef([]);

  // helper: find the best source index to copy active parts/values from
  const findSourceWithActiveParts = () => {
    // prefer the currently active series if it has active parts
    if (seriesStore[activeSeriesIndex]?.AllSeriesPartName?.some((p) => p.active)) {
      return activeSeriesIndex;
    }
    // otherwise find first series that has active parts
    const idx = seriesStore.findIndex((s) => s?.AllSeriesPartName?.some((p) => p.active));
    if (idx !== -1) return idx;
    // fallback to activeSeriesIndex or 0
    return Number.isInteger(activeSeriesIndex) ? activeSeriesIndex : 0;
  };

  // Create the downHandler with useCallback to prevent unnecessary recreations
  const downHandler = useCallback((e) => {
    let { key, code } = e

    if (code === "Space") {
      e.preventDefault(); // page scroll stop
    }
    if (key === 'F5') {
      e.preventDefault()
      dispatch(RESET_1D_SLICE_STATE());
      dispatch(SET_1D_ADVANCE_DRAW_SELECT_TIME([]))
    }
    if (key === 'F1') {
      navigate('resultModal2d')
    }
    if (key === 'F3') {
      navigate('reprint')
    }
    if (key === 'F2') {
      navigate('report')
    }
    if (key === 'F4') {
      navigate('cancel-ticket')
    }
    if (key === 'F9') {
      navigate('advance')
    }

    if (code === "Space") {
      navigate('claim-ticket');
    }
  }, [dispatch, navigate]);

  // Add the keydown event listener for F5, F6, etc.
  useEffect(() => {
    window.addEventListener("keydown", downHandler);

    return () => {
      window.removeEventListener("keydown", downHandler);
    }
  }, [downHandler]);

  useEffect(() => {
    document.addEventListener('keydown', event => {
      if (event.keyCode === 74 || event.keyCode === 2) {
        event.preventDefault();
        return false;
      }
    });
    return () => {
      document.removeEventListener('keydown', null)
    }
  }, [])

  let handleScan = (data) => {
    let ticket_id = data.slice(1)
    dispatch(SET_1D_CLAIM_TICKET_ID(ticket_id))
    navigate('claim-ticket')
  }

  let handleError = (err) => {
    // console.log('err: ', err);
    // dispatch(SHOW_MAIN_ERROR_MODAL('Somthing went wrong'))
    // toast.error('Somthing wrong')
  }

  let resetCode = () => {
    seriesStore.forEach((series) => {
      series.AllSeriesPartName.forEach((partName) => {
        partName.active = false
      })

      series.seriesAllfield.forEach((fields) => {
        fields.forEach(field => {

          field.resetValue()
        })
      })
    })

    dispatch(SET_SERIES_STORE(seriesStore))
    dispatch(SET_ACTIVE_SERIES_INDEX(0))
    dispatch(SET_ACTIVE_SERIES_PART_INDEX(0))
    dispatch(SET_LAST_INPUT_CHANGE_RECORD())
    dispatch(SET_PREVIEWS_ACTIVE_SERIES_DETAIL({ lastSeriesIndex: null, lastSeriesPartIndex: null, isActiveSeriesName: false }))
    dispatch(SET_SERIES_PART_CHECKED(new Array(3).fill(false)))
    dispatch(SET_1D_ADVANCE_DRAW_SELECT_TIME([]))
  }

  const submitBat = useCallback(() => {
    // console.log("✅ submitBat triggered");

    dispatch(SET_MAIN_LOADER(true));

    let newCardDetails = {};
    let totalAmount = 0; // ✅ TOTAL CALCULATION

    resultArray.forEach((resArray, resIndex) => {
      resArray.forEach((_, resultIndex) => {
        const seriesField =
          seriesStore[resIndex]?.seriesAllfield?.[resultIndex] || [];

        seriesField.forEach((inputField) => {
          const val = inputField?.getFinalValue?.() ?? 0;
          if (val > 0) {
            const amount = val;
            newCardDetails[inputField.printNumber] = amount;
            totalAmount += amount; // ✅ ADD TO TOTAL
          }
        });
      });
    });

    // ❌ CONDITION: total 10 se upar hona chahiye
    if (totalAmount < 10) {
        dispatch(
          SHOW_MAIN_ERROR_MODAL(
            "❌ Minimum Bet Amount Total 10 se Zyada Hona Chahiye"
          )
        );
        dispatch(SET_MAIN_LOADER(false));
    return;
    }

    const card_details = { jodi: {} };

    Object.keys(newCardDetails).forEach((key) => {
      const newKey = String(Number(key) % 100).padStart(2, "0");
      card_details.jodi[newKey] = newCardDetails[key];
    });

    const mobile_number = localStorage.getItem("mobile_number") ?? null;

    socket.emit("req", {
      en: "TWO_CHANCE_PLACE_BET",
      data: {
        advance_bet: AdvanceDrawSelectTime.length > 0,
        advance_bet_times: AdvanceDrawSelectTime,
        card_details,
        mobile_number,
      },
    });

    localStorage.removeItem("mobile_number");
  }, [dispatch, resultArray, seriesStore, socket, AdvanceDrawSelectTime]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "F6") {
        event.preventDefault();
        submitBat();
      }
    };

    const handleWhatsappPlaceBet = () => {
      // console.log("📲 whatsappPlaceBet event received");
      submitBat();
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("whatsappPlaceBet", handleWhatsappPlaceBet);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("whatsappPlaceBet", handleWhatsappPlaceBet);
    };
  }, [submitBat]);


  const POINT_MULTIPLIER = 2;

  useEffect(() => {
    if (!socket) return;

    const listener = (socketData) => {
      if (socketData.en === "TWO_CHANCE_PLACE_BET") {

        dispatch(SET_MAIN_LOADER(false));

        if (socketData.err) {
          dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg));
          return;
        }

        dispatch(SET_1D_LAST_SALE_AMOUNT(socketData.data.total_bet_amount));
        dispatch(SET_1D_LAST_TICKET_ID(socketData.data.ticket_id));

        // userDetail ka snapshot yahin read karo
        const currentUserBet = userDetail?.user_bet;

        if (!currentUserBet) {
          PrintData1d(socketData.data, dispatch);
        }

        dispatch(RESET_1D_SLICE_STATE());
        dispatch(SET_1D_ADVANCE_DRAW_SELECT_TIME([]));
        dispatch(setAdvanceTimeSlotCount(0));
      }
    };

    socket.on("res", listener);

    return () => {
      socket.off("res", listener);
    };
  }, [socket]);   // ❗ userDetail hata diya

  const resultArrayA = useMemo(() => {
    return seriesStore.map((series) =>
      series.seriesAllfield.map((field) => {
        let total = 0;
        field.forEach((number) => {
          const value = Number(number.getFinalValue());
          total += value;
        });
        return Math.floor(total);
      })
    );
  }, [seriesStore]);

  const mergedResultArray = useMemo(() => {
    if (!Array.isArray(resultArrayA) || resultArrayA.length === 0) return Array(10).fill(0);
    const merged = Array(10).fill(0);
    resultArrayA.forEach((series) => {
      series.forEach((val, idx) => {
        merged[idx] += Number(val ?? 0);
      });
    });
    return merged;
  }, [resultArrayA]);

  useEffect(() => {
    if (Array.isArray(resultArrayA)) {
      dispatch(SET_RESULT_ARRAY(resultArrayA));
      const total = mergedResultArray.reduce((sum, val) => sum + val, 0);
      setTotalCount(Math.floor(total));
    }
  }, [resultArrayA, mergedResultArray, dispatch]);

  return (
    <>
      <tr className="flex">
        <table width="10%" height="100%" border="0" style={{ borderCollapse: 'collapse', fontSize: '14px' }}>
          <tbody>
            <tr>
              {/* <td style={{ fontSize: "22px", textAlign: "center", fontWeight: "900", textStrokeWidth: "1px", textStrokeColor: 'black', color: "#B0A2C1" }}> 2D</td> */}
            </tr>
            <tr>
              <td>
                <table style={{ width: "100%" }} border="0">
                  <tbody>
                    <tr><td className="checkbox_container" style={{ padding: "0" }}>
                      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        {[
                          { type: "Odd", color: "#01b0f1" },
                          { type: "Family", color: "#FF9900" },
                          { type: "Cross", color: "#ffff00" },
                          { type: "Box25", color: "#77933c" },
                          { type: "Even", color: "#f0a2d2" }
                        ].map((item, index) => (
                          <button
                            key={index}
                            onClick={() => dispatch(SET_SERIES_TYPE(item.type))}
                            disabled={seriesTypeDisableFlag}
                            style={{
                              width: "100%",
                              fontWeight: "bold",
                              borderRadius: "5px",
                              fontSize: "16px",
                              fontWeight: "600",
                              padding: "5px 15px",
                              margin: "3px 0",
                              backgroundColor:
                                seriesType === item.type ? "#e8e8e8" : item.color,

                              border: seriesType === item.type ? "2px solid #19d800ff" : `2px solid ${item.color}`,
                              color: seriesType === item.type ? "#000" : "#000",
                              cursor: "pointer",
                              transition: "0.2s",
                              boxShadow:
                                seriesType === item.type
                                  ? "0px 0px 10px rgba(0,0,0,0.4)"
                                  : "none"
                            }}
                            onMouseEnter={(e) => {
                              if (seriesType !== item.type) {
                                e.target.style.backgroundColor = "#c0504e";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (seriesType !== item.type) {
                                e.target.style.backgroundColor =
                                  seriesType === item.type ? "#e8e8e8" : item.color;
                              }
                            }}
                          >
                            {item.type}
                          </button>
                        ))}
                      </div>
                    </td>


                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <table width="90%" height="100%" style={{ fontSize: '14px' }}>
          <tbody>
            <tr>
              <td>
                <table border="1" cellSpacing="0" cellPadding="0" style={{ borderCollapse: 'collapse' }}>
                  <tbody>
                    <tr>
                      {/* main */}
                      {/* <div className="bet_no_input_box_main select-row-box"> */}
                      {/* main */}
                      {/* <div className="bet_no_input_box"> */}
                      {/* <p className="block_text">BLOCK</p> */}
                      {/* </div> */}
                      {/*  */}
                      {/* </div> */}
                      {/*  */}
                      <HorizontalInputContainer horizontalInputRefs={horizontalInputRefs} verticalInputaRefs={verticalInputaRefs} inputRefs={inputRefs} />
                    </tr>
                    <VerticalInputContainer verticalInputaRefs={verticalInputaRefs} inputRefs={inputRefs} horizontalInputRefs={horizontalInputRefs} />
                  </tbody>
                </table>
              </td>
            </tr>

            <tr className="flex">
              <div className="checkbox_label font-bold text-center px-2" style={{
                width: "10%",
                fontWeight: "bold",
                borderRadius: "5px",
                fontSize: "16px",
                padding: "5px 15px",
                margin: "3px 0",
                background: 'linear-gradient(171.8deg, rgb(18, 113, 235) 13.5%, rgb(13, 57, 112) 78.6%)',

                border: "2px solid #000",
                color: "#fff",
                cursor: "pointer",
                transition: "0.2s",
                boxShadow: "none"
              }} onClick={(e) => {
                e?.preventDefault()
                socket.emit('req', {
                  en: "LOTTARY_CLOSE_GAME",
                  data: {}
                });
                // navigate("/3d");
                localStorage.setItem("gameRoute", "2d")
              }} > 4D</div>
              <div className="checkbox_label font-bold text-center px-2" style={{
                width: "10%",
                fontWeight: "bold",
                borderRadius: "5px",
                fontSize: "16px",
                padding: "5px 15px",
                margin: "3px 0",
                background: 'linear-gradient(171.8deg, rgb(18, 113, 235) 13.5%, rgb(13, 57, 112) 78.6%)',

                border: "2px solid #000",
                color: "#fff",
                cursor: "pointer",
                transition: "0.2s",
                boxShadow: "none"
              }} onClick={(e) => {
                e?.preventDefault()
                socket.emit('req', {
                  en: "LOTTARY_CLOSE_GAME",
                  data: {}
                });
                // navigate("/3d");
                localStorage.setItem("gameRoute", "3d")
              }} > 3D</div>
              <div className="checkbox_label font-bold text-center px-2" style={{
                        width:"10%",
                        fontWeight: "bold",
                        borderRadius: "5px",
                        fontSize: "16px",
                        padding: "5px 15px",
                        margin: "3px 0",
                        background: 'linear-gradient(171.8deg, rgb(18, 113, 235) 13.5%, rgb(13, 57, 112) 78.6%)',

                        border: "2px solid #000",
                        color:  "#fff",
                        cursor: "pointer",
                        transition: "0.2s",
                        boxShadow:"none"
                      }} onClick={(e) => {
                        e?.preventDefault()
                        socket.emit('req', {
                          en: "LOTTARY_CLOSE_GAME",
                          data: {}
                        });
                        // navigate("/3d");
                        localStorage.setItem("gameRoute", "Titli")
                      }} > Titli</div>
              <th width="1%" scope="col">&nbsp;</th>
              <td width="20%" style={{ color: 'black', textAlign: 'center', backgroundColor: '#96B2DA', padding: '0px 15px', fontWeight: '900', border: '1px solid #000' }}>
                <div className="qty_series_no_val">
                  Qty : {advaceTimeSlotCount ? advaceTimeSlotCount * totalCount : totalCount}
                </div>
              </td>
              <th width="1%" scope="col">&nbsp;</th>
              <td width="20%" style={{ color: 'black', textAlign: 'center', backgroundColor: '#96B2DA', fontWeight: '900', border: '1px solid #000' }}>
                <div className="qty_series_no_val">
                  Total : {advaceTimeSlotCount
                    ? advaceTimeSlotCount * totalCount
                    : totalCount}
                </div>
              </td>
              <th width="1%" scope="col">&nbsp;</th>


              <th width="1%" scope="col">&nbsp;</th>
              {userDetail?.print && (<div className="text-center" style={{
                width: "15%",
                fontWeight: "bold",
                borderRadius: "5px",
                fontSize: "16px",
                fontWeight: "bold",
                padding: "5px 15px",
                margin: "3px 0",
                backgroundColor: "#98ff66",
                border: "2px solid #000000",
                color: "#000",
                cursor: "pointer",
                transition: "0.2s",
                boxShadow: "0px 0px 10px rgba(0,0,0,0.4)"
              }}><PlaceBat2d key={'footer'} /></div>)}
              <th width="1%" scope="col">&nbsp;</th>
              {userDetail?.auto_claim == false && (
                <th width="5%" bordercolor="#FFFFFF" bgcolor="#FFFF00" scope="col" style={{
                  width: "10%",
                  fontWeight: "bold",
                  borderRadius: "5px",
                  fontSize: "16px",
                  padding: "5px 15px",
                  margin: "3px 0", background: 'linear-gradient(171.8deg, rgb(71, 89, 255) 13.5%, rgb(10, 106, 34) 78.6%)',

                  border: "2px solid #000",
                  color: "#fff",
                  cursor: "pointer",
                  transition: "0.2s",
                  boxShadow: "none"
                }} onClick={() => navigate('claim-ticket')}>Claim</th>)}
              <th width="1%" scope="col">&nbsp;</th>
              {userDetail?.whatsapp && (
                <th
                  width="5%"
                  bordercolor="#FFFFFF"
                  scope="col"
                  style={{
                    width: "10%", height: "40px", background: "#00FF00",
                    border: " #000 solid 1px"
                  }}
                  onClick={() => setShowWhatsappPopup1d(true)}
                >
                  Whatsapp
                </th>)}
              <th width="1%" scope="col">&nbsp;</th>


              {userDetail?.user_bet && (
                <th
                  width="5%"
                  bordercolor="#FFFFFF"
                  bgcolor="#0004ffff"
                  scope="col"
                  style={{
                    textAlign: 'center',
                    borderWidth: '0px',
                    borderRadius: '5px',
                    padding: '5px 10px',
                    cursor: 'pointer',
                    color: 'white',
                  }}
                  onClick={() => submitBat()}
                >
                  Bet
                </th>)}
            </tr>
          </tbody>
        </table>
        {/* <table width="15%" height="100%" border="0" style={{ fontSize: '14px' }}>
          <tbody>
            <tr>
              <td>
                <RightResultContainer />
              </td>
            </tr>
          </tbody>
        </table> */}
      </tr>
      {showWhatsappPopup1d && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px 30px",
              borderRadius: "10px",
              boxShadow: "0 0 15px rgba(0,0,0,0.3)",
              width: "300px",
              textAlign: "center",
            }}
          >
            <h3 style={{ marginBottom: "15px" }}>Enter Mobile Number</h3>
            <input
              type="tel"
              placeholder="Enter mobile number"
              min='10'
              max='10'
              value={mobileNumber}
              onChange={(e) => {
                const value = e.target.value
                if (value.length > 10) {
                  alert("Mobile number must be 10 digits only")
                  return
                }
                if (/^\d*$/.test(value)) {
                  setMobileNumber(value)
                }
              }}
              style={{
                width: "100%",
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                marginBottom: "15px",
              }}
            />
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <button
                style={{
                  backgroundColor: "#28a745",
                  color: "#fff",
                  border: "none",
                  padding: "8px 12px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (mobileNumber.trim().length < 10) {
                    alert("Please enter a valid mobile number");
                    return;
                  }
                  localStorage.setItem("mobile_number", mobileNumber);

                  // Trigger event
                  window.dispatchEvent(new Event("whatsappPlaceBet"));

                  // close after slight delay
                  setTimeout(() => {
                    setShowWhatsappPopup1d(false);
                    setMobileNumber("");
                  }, 100);
                }}

              >
                Submit
              </button>
              <button
                style={{
                  backgroundColor: "#dc3545",
                  color: "#fff",
                  border: "none",
                  padding: "8px 12px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setShowWhatsappPopup1d(false);
                  setMobileNumber("");
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default MainTable;
